// extracted by mini-css-extract-plugin
export default {"optionCatalogManager":"OptionCatalogManager_optionCatalogManager__g7JwA","optionCatalogHeader":"OptionCatalogManager_optionCatalogHeader__zQcCd"};